import React, { Component } from "react";
export default class MemoryDelayedRecall extends Component {
  render() {
    var {
      delayed_recall_check_1,
      delayed_recall_check_2,
      delayed_recall_check_3,
      delayed_recall_check_4,
      delayed_recall_check_5,
      delayed_recall_check_6,
      delayed_recall_check_7,
      delayed_recall_check_8,
      delayed_recall_check_9,
      delayed_recall_check_10,
      delayed_recall_value,
      delayed_recall_score,
      recall_score,
      percentageMeomeryCall,
    } = this.props.data;
    return (
      <>
        <div className="row border border-dark">
          <div className="col-lg-12">
            <br />
            <ul style={{ paddingLeft: 20, fontSize: 19 }}>
              <li style={{ listStyle: "square" }}>
                Administration:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    Delayed memory recall from the story said outloud in the
                    beginning of ECAS
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Scoring:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    1 point for each (either entire or part of) underlined
                    section recalled.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    The percentage of memory retained is now calculated.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Scoring procedure for retention: obtain delayed recall
                    performance (over page) and, together with immediate recall
                    score, determine percentage retained. Convert percentage
                    retained to Score using table below. If delayed recall = 0,
                    score = 0.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Take the total recall for Delayed Memory and divide it by
                    the Immediate Memory score, before multiplying this number
                    by 100.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    For example: With a Delayed Memory recall of 8 sections, and
                    an Immediate Memory Score of 9/10 The percentage of retained
                    memory is 89%.
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Some patients may recall more at delay than immediate and
                    the percentage will be displayed as being over 100%. Use the
                    conversion table provided in ECAS to derive scoring.
                  </li>
                </ul>
              </li>
              <li style={{ listStyle: "square" }}>
                Say:
                <ul style={{ paddingLeft: 40 }}>
                  <li style={{ listStyle: "circle" }}>
                    “At the beginning of this interview, I read you a story.
                    Tell me as much as you can remember from that story.”
                  </li>
                  <li style={{ listStyle: "circle" }}>
                    Time for recall is unlimited, until participants say that
                    they can remember no more. Self-corrections are allowed;
                    only the final answer is taken for marking.
                  </li>
                </ul>
              </li>
              <li style={{ display: "flex" }}>
                <table cellpadding={8} className="answer-table">
                  <tr>
                    <td style={{ width: 50 }}>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_1"
                        value={delayed_recall_check_1}
                        checked={delayed_recall_check_1 == "1" ? true : false}
                      />
                    </td>
                    <td>Sunday</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_2"
                        value={delayed_recall_check_2}
                        checked={delayed_recall_check_2 == "1" ? true : false}
                      />
                    </td>
                    <td>Annual Park Cleanup</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_3"
                        value={delayed_recall_check_3}
                        checked={delayed_recall_check_3 == "1" ? true : false}
                      />
                    </td>
                    <td>Marigold Woods</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_4"
                        value={delayed_recall_check_4}
                        checked={delayed_recall_check_4 == "1" ? true : false}
                      />
                    </td>
                    <td>Forty two </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_5"
                        value={delayed_recall_check_5}
                        checked={delayed_recall_check_5 == "1" ? true : false}
                      />
                    </td>
                    <td>Bicycles and shopping carts</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_6"
                        value={delayed_recall_check_6}
                        checked={delayed_recall_check_6 == "1" ? true : false}
                      />
                    </td>
                    <td>Robert Webber</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_7"
                        value={delayed_recall_check_7}
                        checked={delayed_recall_check_7 == "1" ? true : false}
                      />
                    </td>
                    <td>Woodland project</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_8"
                        value={delayed_recall_check_8}
                        checked={delayed_recall_check_8 == "1" ? true : false}
                      />
                    </td>
                    <td>Very impressed and especially proud</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_9"
                        checked={delayed_recall_check_9 == "1" ? true : false}
                      />
                    </td>
                    <td>17</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        name="delayed_recall_check_10"
                        checked={delayed_recall_check_10 == "1" ? true : false}
                      />
                    </td>
                    <td>children</td>
                  </tr>
                </table>
              </li>
              <li>
                <div className="row" style={{ marginTop: 30 }}>
                  <div className="col-lg-6 pl-0">
                    <p className="fs-19">
                      Delayed recall =
                      <input
                        type="text"
                        name="delayed_recall_value"
                        className="ecas-input-field text-left"
                        placeholder="Delayed recall"
                        value={delayed_recall_value}
                        onChange={this.handleChange}
                      />
                    </p>{" "}
                  </div>
                  <div className="col-lg-6">
                    <span className="fs-19">Score (0 - 10) </span>
                    <input
                      type="number"
                      name="delayed_recall_score"
                      value={delayed_recall_score}
                      onChange={this.handleChange}
                      className="ecas-input-field"
                      placeholder="Score"
                    />
                  </div>
                </div>
              </li>
            </ul>
            <hr />
          </div>
        </div>
        <div className="row border border-dark">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-6 border-right">
                <div className="row border border-dark grey">
                  <div className="col-lg-12">
                    <div className="text-left py-4 font-weight-medium fs-17">
                      Delayed recall to percentage retained calculation
                    </div>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-5 pr-0 text-center align-item-center">
                    (Delayed recall) <br />
                    ------------------------------------------------ <br />
                    (Immediate recall score)
                  </div>
                  <div className="col-lg-3 pt-3 px-0 text-center">
                    x 100 = % retained
                  </div>
                </div>

                <div className="row mt-4 mb-3">
                  <div className="col-lg-5 pr-0 text-align-center align-item-center">
                    <input
                      disabled
                      type="text"
                      name="delayed_recall_value"
                      className="ecas-input-field col-lg-9 ml-3 text-align-center"
                      placeholder="Delayed Recall"
                      value={delayed_recall_value}
                      style={{
                        width: 70,
                        marginBottom: -1,
                        maxHeight: 43,
                        marginLeft: "38px !important",
                      }}
                    />
                    <br />
                    <div style={{ marginLeft: 12 }}>---------------------</div>
                    <input
                      disabled
                      type="text"
                      name="recall_score"
                      className="ecas-input-field col-lg-9 ml-3 text-align-center"
                      placeholder="Immediate recall score"
                      value={recall_score}
                      style={{
                        width: 70,
                        maxHeight: 43,
                        marginLeft: "38px !important",
                        marginTop: 0,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      paddingTop: 44,
                      position: "relative",
                      left: -58,
                    }}
                    className="col-lg-5 px-0 text-align-center"
                  >
                    x 100 = {percentageMeomeryCall}% retained
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row border border-dark grey">
                  <div className="col-lg-12">
                    <div className="text-left py-4 font-weight-medium fs-17">
                      Percentage retained to score conversion table
                    </div>
                  </div>
                </div>
                <table
                  cellPadding={7}
                  className="my-2 w-100 table-black w-100 border border-dark text-align-center"
                >
                  <tbody>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                        }}
                      >
                        Percentage retained
                      </th>
                      <th
                        style={{
                          border: "1px solid #000",
                        }}
                      >
                        Score
                      </th>
                      <th
                        style={{
                          border: "1px solid #000",
                        }}
                      >
                        Percentage retained
                      </th>
                      <th
                        style={{
                          border: "1px solid #000",
                        }}
                      >
                        Score
                      </th>
                    </tr>
                    <tr>
                      <td>1-10%</td>
                      <td>1</td>
                      <td>51-60%</td>
                      <td>6</td>
                    </tr>
                    <tr>
                      <td>11-20%</td>
                      <td>2</td>
                      <td>61-70%</td>
                      <td>7</td>
                    </tr>
                    <tr>
                      <td>21-30%</td>
                      <td>3</td>
                      <td>71-80%</td>
                      <td>8</td>
                    </tr>
                    <tr>
                      <td>31-40%</td>
                      <td>4</td>
                      <td>81-90%</td>
                      <td>9</td>
                    </tr>
                    <tr>
                      <td>41-50%</td>
                      <td>5</td>
                      <td>91-100+ %</td>
                      <td>10</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
